import { render, staticRenderFns } from "./FormItemTextarea.vue?vue&type=template&id=074501b1"
import script from "./FormItemTextarea.vue?vue&type=script&lang=ts"
export * from "./FormItemTextarea.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports